import React from "react";

const PrimaryMetalsIndustryIcon = ({ color = "#5D5D5D", size = 35 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Table top */}
      <rect x="6" y="6" width="20" height="2.5" fill={color} />

      {/* Outer frame extended to legs */}
      {/* Outer frame (box only, no legs) */}
<rect x="8" y="8.5" width="16" height="14" stroke={color} strokeWidth="1.9" fill="none" />

{/* Legs as thin lines */}
<line x1="10" y1="21.5" x2="10" y2="26.5" stroke={color} strokeWidth="2" />
<line x1="22" y1="21.5" x2="22" y2="26.5" stroke={color} strokeWidth="2" />


      {/* Horizontal divider */}
      <line x1="8" y1="13.5" x2="24" y2="13.5" stroke={color} strokeWidth="2" />

      {/* Thin vertical line only between eyes */}
      <line x1="16" y1="8.5" x2="16" y2="13.5" stroke={color} strokeWidth="1" />

      {/* Eyes - centered in top section */}
      <rect x="10" y="10.75" width="3" height="2" fill={color} />
      <rect x="19.5" y="10.75" width="3" height="2" fill={color} />

      {/* Mouth (handle) - raised slightly for balance */}
      <rect x="14" y="17.25" width="4" height="2" fill={color} />
    </svg>
  );
};

export default PrimaryMetalsIndustryIcon;
